import styled from 'styled-components/native';
import { Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient'

export const Poster = styled.ImageBackground`
  width: 100%;
  height: ${(Dimensions.get("window").height * 70) / 100}px;
`;

export const Container = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  contentContainerStyle: {
    flexDirection: "column",
    flexBasis: "auto",
  },
})`  
  `;

export const Content = styled.View`
    
`;

export const Gradient = styled(LinearGradient)`
    height: 100%;
`;

export const Hero = styled.View`
    position: absolute;
    width: 100%;
    bottom: 3rem;
    padding: 0.5rem 1rem;
`;
export const ViewButton = styled.View`
  justify-content: center;
`;

export const ContentIcon = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding-vertical: 8px;
  padding-horizontal: 12px;
  border-radius: ${({ borderRadius }) => borderRadius};
  border-color: ${({ borderColor }) => (borderColor ? borderColor: 'transparent')};
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : '#a6a5a4')};
  border-width: 1px;
  margin-right: 12px;
`;
